<template>
  <div class="client-quotation">
    <!-- <b-tabs pills card>
                <b-tab title="Booking Request" active
                    ><b-card-text> -->
    <SelectType v-model="request_quotation.service_type" />

    <component v-if="request_quotation.service_type" :is="checkServiceReturnComponent(request_quotation.service_type)"
      :value.sync="request_quotation" ref="LCLBookingKH" :readonly="readonly" />

    <div class="text-right">
      <a v-if="!readonly" @click="sendRequestQuotation" class="btn round btn-success pl-4 pr-4 mr-1">
        <feather-icon icon="SendIcon" /> New Booking
      </a>
    </div>
    <!-- </b-card-text
                ></b-tab>

                <b-tab disabled title="Quote"
                    ><b-card-text>Tab contents 2</b-card-text></b-tab
                >
            </b-tabs> -->
  </div>
</template>

<script>
import SelectType from "./components/SelectType.vue";
import { $ctx } from "@themeConfig";
import moment from "moment";
import LCLBooking from "./LCLBooking.vue";
import { ValidationObserver } from "vee-validate";
import { mapState } from "vuex";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import useJwt from "@/auth/jwt/useJwt";

export default {
  props: {
    view_RequestQuotation: { default: null },
    readonly: false,
    serviceType: null,
    isCopy: {
      default: false
    }
  },
  components: {
    SelectType,
    LCLBooking,
    ValidationObserver,
    ToastificationContent,
  },
  watch: {
    mySelection(newValue) {
      this.request_quotation.service_type = newValue;
    },
  },
  computed: {
    mySelection() {
      this.request_quotation.service_type = this.serviceType;
      this.checkServiceReturnComponent(this.serviceType);
      return this.serviceType;
    },
    ...mapState("masterData", [
      "service_types",
      "ports",
      "incoterms",
      "cont_types",
      "goods_types",
      "transport_types",
      "deports_locations",
      "deports",
      "business_types",
      "customs_types",
      "shipping_lines",
      "regions",
      "companyItems",
      "fee_types",
      "handed_types",
    ]),
  },

  data() {
    return {
      modalSchedule: false,
      buttonKey: 1,
      moment,
      showTimePanel: false,
      showTimeRangePanel: false,
      isHideShow: false,
      isHideShowPk: false,
      vm: this,
      pod_name: null,
      pol_name: null,
      userData: JSON.parse(localStorage.getItem("userData")),
      locationsByUser: [],
      request_quotation: {
        has_d2d_trucking: false,
        has_van_trucking: false,
        has_customs: false,
        //có
        eta: null,
        //có
        etd: null,
        //có
        transit_port: null,
        customs_other_service_type: null,
        has_container_trucking: null,
        isHideShows: false,
        isHideShowPks: false,
        other_pickup_location: null,
        other_delivery_location: null,
        pickup_location: null,
        delivery_location: null,
        other_pickup_region: null,
        other_delivery_region: null,
        pickup_region: null,
        delivery_region: null,
        //có
        company_id: null,
        //có
        customer_id: null,
        service_type: "3",
        //có
        pod_port: null,
        //có
        pol_port: null,
        incoterms: null,
        cont_type: null,
        //có
        goods_type: null,
        // package_type: null,
        transport_type: null,
        deport: null,
        business_type: null,
        so_luong: null,
        trong_luong: null,
        mo_ta: null,
        volume: null,
        from_date: null,
        to_date: null,
        other_service: null,
        //có
        notes: null,
        so_khoi: null,
        so_kien: null,
        shipping_line: null,
        place_of_stuffing: null,
        totalChargeWeight: null,
        size_: {
          length_: null,
          width_: null,
          height_: null,
        },
        //có
        cargo_ready: moment().format("DD/MM/YY HH:mm"),
        customs_addr: null,
        hs_code: null,
        company_name: null,
        company_tax: null,
        //có
        cargo_ready_date: null,
        //có
        cargo_ready_time: "00:00",
        //có
        quotation: null,
        cargo_ready_address: null,
        //có
        commodity: null,
        //có
        showAddMore: [
          {
            id: 1,
            hasDelete: false,
            showAddMoreLine: [
              {
                id: 2,
                hasDelete: false,
                gross_weight: null,
                volume: null,
                packages: null,
                dimension: {
                  lenght: null,
                  width: null,
                  height: null,
                },
              },
            ],
            package_type: null,
            total_packages: 0,
            gross_weight_total: 0,
            volume_total: 0,
          },
        ],
        //có
        isPOL_VN: false,
        isPOD_VN: false,
        //có
        prepaid: true,
        collect: false,

        //có
        stack_able: true,
        non_stack_able: false,
        rotatable: false,
        oversize: false,
        overweight: false,

        // có
        custom_service: false,
        custom_service_other: false,
        door_service: false,
        inland: false,
        inland_other1: false,
        inland_other2: false,
        insurance: false,
        insurance: false,
        packaging: false,
        labeling: false,
        securing_of_load: false,
        liquidation: false,
        weighing: false,
        customs_type_input: "",
        custom_place: "",
        custom_hs_code: "",
        commodity_policy: false,
        door_pick_up_input: "",
        door_delivery_input: "",
        door_contact_pick_up: {
          name: "",
          phone: "",
          email: "",
        },
        door_contact_delivery: {
          name: "",
          phone: "",
          email: "",
        },
        inland_pick_up_input: "",
        inland_pick_up_date: "",
        inland_pick_up_time: "",
        inland_pick_up_date_time: "",
        inland_contact_pick_up: {
          name: "",
          phone: "",
          email: "",
        },
        inland_contact_delivery: {
          name: "",
          phone: "",
          email: "",
        },
        inland_delivery_input: "",
        inland_delivery_date: "",
        inland_delivery_time: "",
        inland_delivery_date_time: "",

      },

      customer_list_options: null,

      volumes: [
        { id: 1, text: "1-10" },
        { id: 2, text: "10-30" },
        { id: 3, text: "30-50" },
        { id: 4, text: "50-100" },
        { id: 5, text: ">100" },
      ],
      currencies: [
        { id: "VND", text: "VNĐ" },
        { id: "USD", text: "USD" },
      ],
      dropzoneOptions: {
        url: $ctx.API_URL + this.$Utils.CONSTANTS.TYPE_UPLOAD.URL,
        addRemoveLinks: !this.readonly,
        acceptedFiles: this.$Utils.CONSTANTS.TYPE_UPLOAD.type,
        maxFilesize: this.$Utils.CONSTANTS.TYPE_UPLOAD.size,
        maxFiles: this.$Utils.CONSTANTS.TYPE_UPLOAD.max,
        headers: { apiKey: localStorage.getItem("accessToken") },
        clickable: !this.readonly,
      },
      customer_list: null,
      useName: null,
      costs: [],

      countRq: 0,
    };
  },
  created() {
    if (this.view_RequestQuotation != null) {
      this.request_quotation = this.view_RequestQuotation;
      this.isHideShow =
        this.view_RequestQuotation.other_pickup_location != null ? true : false;

      this.isHideShowPk =
        this.view_RequestQuotation.other_delivery_location != null
          ? true
          : false;

      this.isHideShow =
        this.view_RequestQuotation.other_pickup_region != null ? true : false;

      this.isHideShowPk =
        this.view_RequestQuotation.other_delivery_region != null ? true : false;
      !this.request_quotation.size_
        ? (this.request_quotation = {
          ...this.request_quotation,
          size_: {
            length_: null,
            width_: null,
            height_: null,
          },
        })
        : "";
    }
  },
  mounted() {
    this.request_quotation.company_id = this.companyItems.find(
      (e) => e.name == this.userData.companyName
    )?.code;

    this.request_quotation.customer_id = this.userData.username;


  },
  methods: {
    async sendRequestQuotation() {
      //TODO them api upfile

      let route = this.$router;
      // this.request_quotation.files = [];
      // for (
      //   var i = 0;
      //   i <
      //   this.$refs.LCLBookingKH.$refs.AttachFile.$refs.myVueDropzone.getAcceptedFiles()
      //     .length;
      //   i++
      // ) {
      //   var file = JSON.parse(
      //     this.$refs.LCLBookingKH.$refs.AttachFile.$refs.myVueDropzone.getAcceptedFiles()[
      //       i
      //     ].xhr.response
      //   ).result;
      //   file.size =
      //     this.$refs.LCLBookingKH.$refs.AttachFile.$refs.myVueDropzone.getAcceptedFiles()[
      //       i
      //     ].size;
      //   file.date = moment(new Date()).format("DD/MM/YYYY HH:mm:ss");
      //   file.uuid =
      //     this.$refs.LCLBookingKH.$refs.AttachFile.$refs.myVueDropzone.getAcceptedFiles()[
      //       i
      //     ].upload.uuid;
      //   file.username = this.userData.username;
      //   file.fullName = this.userData.fullName;
      //   this.request_quotation.files.push(file);
      // }

      var validate =
        // await this.$refs.LCLBookingKH.$refs.requestQuotationRules
        await this.$refs.LCLBookingKH.$refs.Routing.$refs.validateRouting
          .validate()
          .then((success) => {
            return success;
          });

      if (!validate) {
        this.activeTab = 0;
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Please check the requested Routing Details data!",
            icon: "AlertTriangleIcon",
            variant: "warning",
          },
        });
        return;
      }
      validate =
        // await this.$refs.LCLBookingKH.$refs.requestQuotationRules
        await this.$refs.LCLBookingKH.$refs.Sailing.$refs.validateSailing
          .validate()
          .then((success) => {
            return success;
          });

      if (!validate) {
        this.activeTab = 0;
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Please check the requested Sailing Schedule data!",
            icon: "AlertTriangleIcon",
            variant: "warning",
          },
        });
        return;
      }
      validate =
        // await this.$refs.LCLBookingKH.$refs.requestQuotationRules
        await this.$refs.LCLBookingKH.$refs.Cargo.$refs.validateCargo
          .validate()
          .then((success) => {
            return success;
          });

      if (!validate) {
        this.activeTab = 0;
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Please check the requested Cargo Detail data!",
            icon: "AlertTriangleIcon",
            variant: "warning",
          },
        });
        return;
      }

      if (!this.request_quotation.collect && !this.request_quotation.prepaid) {
        this.activeTab = 0;
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Please check the requested Freight Term data!",
            icon: "AlertTriangleIcon",
            variant: "warning",
          },
        });
        return;
      }
      if (
        !this.request_quotation.stack_able &&
        !this.request_quotation.non_stack_able &&
        !this.request_quotation.rotatable
      ) {
        this.activeTab = 0;
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Please check the requested Sailing Schedule data!",
            icon: "AlertTriangleIcon",
            variant: "warning",
          },
        });
        return;
      }

      let service = "RequestBooking";
      this.$loading.show();
      if (this.view_RequestQuotation != null && this.isCopy == false) {
        useJwt
          .put("wr1?objectType=" + service, this.request_quotation)
          .then((response) => {
            this.$emit("ok-clicked");
            if (this.step == null || this.step == "created-quotation") {
              this.$emit("sendRequestQuotationEvent");
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: this.$i18n.t("bookingSaleSuccess"),
                  icon: "CheckSquareIcon",
                  variant: "primary",
                },
              });
            } else {
              this.$emit("sendRequestBookingEvent");
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: this.$i18n.t("bookingSaleSuccess"),
                  icon: "CheckSquareIcon",
                  variant: "primary",
                },
              });
            }
          })
          .catch((error) => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: this.$i18n.t("bookingSaleError"),
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            });
          })
          .finally(() => {
            this.$emit("ok-clicked");
            this.$loading.hide();
          });
      } else {
        useJwt
          .post("wr1?objectType=" + service, this.request_quotation)
          .then((response) => {


            // khách hàng tạo mới booking tạo xong thì upfile 
            if (response.data.meta.booking_id) {
              var files = [];
              for (
                var i = 0;
                i <
                this.$refs.LCLBookingKH.$refs.AttachFile.$refs.myVueDropzone.getAcceptedFiles()
                  .length;
                i++
              ) {
                var file = JSON.parse(
                  this.$refs.LCLBookingKH.$refs.AttachFile.$refs.myVueDropzone.getAcceptedFiles()[
                    i
                  ].xhr.response
                ).result;
                file.size =
                  this.$refs.LCLBookingKH.$refs.AttachFile.$refs.myVueDropzone.getAcceptedFiles()[
                    i
                  ].size;
                file.date = moment(new Date()).format("DD/MM/YYYY HH:mm:ss");
                file.uuid =
                  this.$refs.LCLBookingKH.$refs.AttachFile.$refs.myVueDropzone.getAcceptedFiles()[
                    i
                  ].upload.uuid;
                file.username = this.userData.username;
                file.fullName = this.userData.fullName;
                file.isRequestFile = "1";
                file.uuid =
                  this.$refs.LCLBookingKH.$refs.AttachFile.$refs.myVueDropzone.getAcceptedFiles()[i].upload.uuid;
                file.bookingId = response.data.meta.booking_id;

                files.push(file);

                this.$store.dispatch("attachFile/upFile", file);
              }
            }

            this.$emit("ok-clicked");
            this.$toast({
              component: ToastificationContent,
              props: {
                title: this.$i18n.t("bookingSaleSuccess"),
                icon: "CheckSquareIcon",
                variant: "primary",
              },
            });
            if (this.step == null || this.step == "created-quotation") {
              this.$emit("sendRequestQuotationEvent");
            } else {
              this.$emit("sendRequestBookingEvent");
            }
          })
          .catch((error) => {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: this.$i18n.t("bookingSaleError"),
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            });
          })
          .finally(() => {
            this.$loading.hide();
          });
      }
    },
    checkServiceReturnComponent(type) {
      if (type === "LCL" || type.toString() === "3") {
        return "LCLBooking";
      } else {
        return "";
      }
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/customs/request-quotation.scss";
@import "@core/scss/customs/inputV2.scss";
</style>
